import styled from 'styled-components'

export const ButtonContainer = styled.div`
  display: grid;
  grid-template-areas:
    'rock scissors'
    'paper paper';
  grid-gap: 20px;
  justify-content: center;
  align-items: center;
  margin: 20px;

  @media screen and (max-width: 768px) {
    grid-template-areas:
      'rock'
      'scissors'
      'paper';
  }
`

export const ChoiceButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`

export const ChoiceImage = styled.img`
  width: 120px;
  height: 120px;

  @media screen and (max-width: 768px) {
    width: 80px;
    height: 80px;
  }
`
